/** Must match backend CLIENT_DELETION_GRACE_DAYS (default 90). */
export const CLIENT_DELETION_GRACE_DAYS =
  parseInt(process.env.REACT_APP_CLIENT_DELETION_GRACE_DAYS || "90", 10) || 90;
